// MultiSelect.js

import React, { useState } from "react";

const MultiSelect = (props) => {
  const [input, setInput] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const {
    options,
    label,
    placeholder,
    isValid,
    errorMsg,
    selected = [],
    onChange,
    onInputChange,
  } = props;

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);
    setShowDropdown(true);
    if (onInputChange && e.target.value.length > 2) {
      onInputChange(value);
    }else if (onInputChange && e.target.value.length == 0){
      onInputChange("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && input === "" && selected.length > 0) {
      removeItem(selected[selected.length - 1]);
    }
  };

  const addItem = (item) => {
    const updatedSelected = [...selected, item];

    setInput("");
    setShowDropdown(false);

    if (onChange) {
      onChange(updatedSelected);
    }
  };

  const removeItem = (item) => {
    const updatedSelected = selected.filter(
      (selectedItem) =>
        (selectedItem.value || selectedItem) !== (item.value || item)
    );

    if (onChange) {
      onChange(updatedSelected);
    }
  };

  const searchTerm = input.toLowerCase().trim();

  // Only hide already selected items; backend handles search filtering.
  const filteredOptions = options.filter((item) => {
    const isSelected = selected.some(
      (s) => (s.value || s) === (item.value || item)
    );
    return !isSelected;
  });

  return (
    <div style={styles.wrapper}>
      <div
        onClick={() => setShowDropdown(true)}
        style={{
          ...styles.container,
          cursor: "text",
          borderBottom: !isValid
            ? "2px solid red"
            : showDropdown || input
            ? "2px solid #152C8C"
            : "1px solid #d2d2d2",
        }}
      >
        {selected &&
          selected.length > 0 &&
          selected.map((item, index) => (
            <div
              key={item.value || item.pzInsKey || item.DrugName || index}
              style={styles.tag}
            >
              <span>
                {item.GenericName && item.GenericName !== "undefined" ? item.DrugName == "Other" ? item.DrugName : `${item.DrugName}-${item.GenericName}` : item.DrugName}
              </span>

              <span
                style={styles.close}
                onClick={(e) => {
                  e.stopPropagation();
                  removeItem(item);
                }}
              >
                ×
              </span>
            </div>
          ))}

        <input
          type="text"
          value={input}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onFocus={() => setShowDropdown(true)}
          onClick={() => setShowDropdown(true)}
          onBlur={() =>
            setTimeout(() => setShowDropdown(false), 250)
          }
          style={styles.input}
          placeholder={selected.length === 0 ? " " : ""}
          autoComplete="off"
        />

        <span style={styles.arrow}>
          <svg
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L5 5L9 1"
              stroke="#333"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>

      <label
        style={{
          ...styles.label,
          ...(showDropdown || input || selected.length > 0
            ? styles.labelFloating
            : {}),
          color: !isValid
            ? "#f55858"
            : showDropdown
            ? "#152C8C"
            : "#9b9b9b",
        }}
      >
        {label}
      </label>

      {!isValid && (
        <span style={styles.errorMsg}>
          {errorMsg || "Please select or input a valid value"}
        </span>
      )}

      {showDropdown && (
        <div style={styles.dropdown}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item, index) => (
              <div
                key={
                  item.value ||
                  item.pzInsKey ||
                  `${item.DrugName}-${index}`
                }
                style={styles.option}
                onMouseDown={(e) => {
                  e.preventDefault();
                  addItem(item);
                }}
              >
                {item.GenericName && item.GenericName !== "undefined" ? item.DrugName == "Other" ? item.DrugName : `${item.DrugName}-${item.GenericName}` : item.DrugName}
              </div>
            ))
          ) : (
            input.length > 0 && (
              <div
                style={{
                  ...styles.option,
                  cursor: "default",
                  color: "#999",
                }}
              >
                No medications found
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

const styles = {
  wrapper: {
    position: "relative",
    paddingTop: "15px",
    marginTop: "10px",
    width: "100%",
  },

  label: {
    position: "absolute",
    top: "22px",
    left: "0px",
    fontSize: "13px",
    color: "#9b9b9b",
    transition: "0.2s",
    pointerEvents: "none",
  },

  labelFloating: {
    top: "0px",
    fontSize: "12px",
  },

  container: {
    border: "none",
    borderBottom: "1px solid #d2d2d2",
    borderRadius: "0px",
    padding: "4px 0px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    minHeight: "30px",
    gap: "5px",
    backgroundColor: "transparent",
    position: "relative",
  },

  tag: {
    background: "#AB00DE",
    color: "#FFFFFF",
    padding: "2px 8px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "12px",
    margin: "2px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },

  close: {
    cursor: "pointer",
    fontWeight: "bold",
  },

  input: {
    border: "none",
    outline: "none",
    flex: 1,
    minWidth: "120px",
    height: "25px",
    fontSize: "14px",
    backgroundColor: "transparent",
    color: "#555",
  },

  arrow: {
    position: "absolute",
    right: "0",
    top: "10px",
    pointerEvents: "none",
  },

  dropdown: {
    position: "absolute",
    width: "100%",
    background: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginTop: "5px",
    maxHeight: "150px",
    overflowY: "auto",
    zIndex: 1000,
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  },

  errorMsg: {
    color: "red",
    fontSize: "11px",
    marginTop: "4px",
    display: "block",
  },

  option: {
    padding: "10px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
  },
};

export default MultiSelect;